import { AllFeatureTypes as PermissionsCenterFeatureType } from 'features-op/permissions-center/types';
import { FeatureName, FeatureSelection } from 'hooks/dialogs/cluster/types';

type MappableToPermissionsCenterFeature = Exclude<
  FeatureName,
  | 'kent'
  | 'networkCostMetrics'
  | 'gpuMetricsExporter'
  | 'nvidiaGpuPlugin'
  | 'reliabilityMetrics'
>;

const FEATURE_NAME_TO_PERMISSIONS_CENTER_FEATURE_TYPE: Record<
  MappableToPermissionsCenterFeature,
  PermissionsCenterFeatureType | undefined
> = {
  autoscaler: 'NODE_AUTOSCALING',
  omni: 'OMNI',
  costMonitoring: 'COST_MONITORING',
  workloadAutoscaler: 'WORKLOAD_AUTOSCALING',
  // Security is not implemented in permissions center (and perhaps won't be)
  security: undefined,
};

const isFeatureMappableToPermissionsCenterFeature = (
  feature: string
): feature is MappableToPermissionsCenterFeature => {
  return feature in FEATURE_NAME_TO_PERMISSIONS_CENTER_FEATURE_TYPE;
};

export const mapFeatureSelectionToPermissionsCenterFeatures = (
  selectedFeatures: FeatureSelection
): PermissionsCenterFeatureType[] => {
  return Object.entries(selectedFeatures).reduce<
    PermissionsCenterFeatureType[]
  >((permissionsCenterFeatures, [featureName, isSelected]) => {
    if (
      isSelected &&
      isFeatureMappableToPermissionsCenterFeature(featureName) &&
      FEATURE_NAME_TO_PERMISSIONS_CENTER_FEATURE_TYPE[featureName]
    ) {
      permissionsCenterFeatures.push(
        FEATURE_NAME_TO_PERMISSIONS_CENTER_FEATURE_TYPE[featureName]
      );
    }
    return permissionsCenterFeatures;
  }, []);
};
